import HoverCard from '@/common/components/HoverCard'
import Skeleton from '@/common/components/Skeleton'
import { formatDecimal } from '@/common/utils/formatters'
import { CardsTotalizerData } from '@/features/cards/types/cardsTotalizer.type'
import { CreditCard } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface CompanyCardsHoverCardProps {
  setCompanyIdToSeeCardsInfo: (companyId: string) => void,
  cardsTotalizer: CardsTotalizerData,
  isPendingCards: boolean
  companyId: string
}

export default function CompanyCardsHoverCard({
  setCompanyIdToSeeCardsInfo,
  cardsTotalizer,
  isPendingCards,
  companyId
}: CompanyCardsHoverCardProps) {
  const navigate = useNavigate();

  const EXCLUDED_STATUS = ['blocked']

  const totalCards = cardsTotalizer?.per_status && Object.entries(cardsTotalizer?.per_status)
    .filter(([status]) => !EXCLUDED_STATUS.includes(status))
    .reduce((total, [, value]) => total + value, 0)

  return (
    <HoverCard
      openDelay={10}
      closeDelay={100}
      trigger={
        <CreditCard
          onMouseEnter={() => {
            setCompanyIdToSeeCardsInfo(companyId)
          }}
          onClick={() => navigate(`/companies/${companyId}/cards`)}
          className="max-w-4 cursor-pointer"
        />
      }
      className="bg-white-200 backdrop-blur-xl border-0 -mr-4 p-4 rounded-md"
      align="end"
    >
      <div className="flex flex-col gap-4">
        <div className='flex gap-2'>
          <p className={`font-light italic text-[14px] text-[#fff]`}>Total em cartões:</p>
          <p className={`text-[18px] text-[#fff]`}>{isPendingCards ? <Skeleton className='max-w-12' /> : formatDecimal(Number(totalCards || 0), 0)}</p>
        </div>

        <div className='flex gap-2'>
          <p className={`font-light italic text-[14px] text-valid`}>Cartões ativos:</p>
          <p className={`text-[18px] text-valid`}>{isPendingCards ? <Skeleton className='max-w-12' /> : formatDecimal(Number(cardsTotalizer?.per_status?.active || 0), 0)}</p>
        </div>

        <div className='flex gap-2'>
          <p className={`font-light italic text-[14px] text-yellow-400`}>Cartões bloqueados:</p>
          <p className={`text-[18px] text-yellow-400`}>{isPendingCards ? <Skeleton className='max-w-12' /> : formatDecimal(Number(cardsTotalizer?.per_status?.blocked || 0), 0)}</p>
        </div>
      </div>
    </HoverCard>
  )
}
